export class Confirmation {
  public titleKey = 'shared.confirmation.confirmTitle';
  public messageKey = '';
  public messageParams: { [key: string]: string } = {};

  public confirmKey = 'shared.confirmation.confirm';
  public cancelKey = 'shared.confirmation.cancel';

  public constructor(confirmation: Partial<Confirmation>) {
    Object.assign(this, confirmation);
  }
}
